jQuery(document).ready(function ($) {

   // ZIP LOCATIONS
   var zip_location_1 = ['08036', '08048', '08052', '08053', '08054', '08055', '08057', '08060', '08065', '08077', '08002', '08003', '08004', '08007', '08009', '08012', '08021', '08026', '08029', '08030', '08031', '08033', '08034', '08035', '08043', '08045', '08049', '08059', '08078', '08081', '08083', '08084', '08089', '08091', '08095', '08102', '08103', '08104', '08105', '08106', '08107', '08108', '08109', '08110', '19087', '19301', '19312', '19333', '19341', '19345', '19355', '19041', '19085', '19010', '08014', '08020', '08027', '08028', '08051', '08056', '08061', '08062', '08063', '08066', '08071', '08074', '08080', '08085', '08086', '08090', '08093', '08094', '08096', '08097', '19127', '19128', '19131', '19151', '19003', '19004', '19035', '19066', '19072', '19096', '19401', '19403', '19405', '19406', '19428', '19444', '19462'];

   var zip_location_2 = ['19122', '19020', '19021', '19013', '19380', '19382', '19383', '19022', '19043', '19050', '19060', '19061', '19063', '19064', '19070', '19073', '19074', '19076', '19078', '19079', '19081', '19082', '19083', '19086', '19094', '19113', '19317', '19319', '19342', '19373', '19008', '19014', '19015', '19017', '19018', '19023', '19026', '19029', '19032', '19033', '19036', '19111', '19114', '19115', '19116', '19120', '19124', '19125', '19126', '19129', '19132', '19133', '19134', '19135', '19136', '19137', '19139', '19140', '19142', '19143', '19149', '19152', '19153', '19154', '19001', '19006', '19009', '19012', '19027', '19040', '19044', '19046', '19090'];

   var zip_location_3 = ['08230', '08225', '08234', '08221', '08401', '08403', '08406', '08402', '08232', '08242', '08243', '08247', '08248', '08260', '08202', '08204', '08210', '08212', '08223', '08226', '08244'];

   var zip_location_4 = ['19102', '19103', '19104', '19106', '19107', '19112', '19121', '19123', '19130', '19145', '19146', '19147', '19148'];

   var zip_location_5 = ['19118', '19119', '19138', '19141', '19144', '19150', '18936', '19002', '19025', '19031', '19034', '19038', '19075', '19095', '19422', '19436', '19437', '19477'];


   function getCartTotal(callback){

   $.getJSON('/cart.js', function(cart){

      var cartTotal = cart.total_price / 100;

      callback(cartTotal);

   });

}

$(document).on("input blur", 'input[name="updates[]"]', function(){

   getCartTotal(function(cartTotal){

      console.log(cartTotal);

    if (
   cartTotal < 250 &&
   $('input[name="note_text"]:checked').val() === "Delivery"
)

{

         //alert("Delivery requires minimum order of $250");

     // $('#checkoutButton').hide();

     // $("#zipMessage0").text('Delivery requires minimum order of $250');

   

         return false;

      }

      else {
           $('#checkoutButton').show();
   }
      })

});







      // RESET
  let  allowedDays = [];

   // UPDATE DELIVERY NOTE
   $("#zip").on("keyup", function () {


      console.log('works')

      var dateVal = $("#date").val();
      const zipVal = $("#zip").val();

      // $("#curbside-message").val(
      //    "DELIVERY on " + dateVal + " for zip - " + zipVal
      // );

   });



   $("#curbside-message").on("change keyup focus input", function () {

      console.log("allow for picup")

         allowedDays = [0, 2, 3, 4, 5, 6];


   })

  

   $("#zip").on("change", function () {

   const zipVal = $(this).val().trim();

   var message = "";

   // RESET
   allowedDays = [];

   if (zip_location_1.includes(zipVal)) {
       allowedDays = [2, 5];
      message = "Available delivery days: Tuesday & Friday";
   }

   else if (zip_location_2.includes(zipVal)) {
      allowedDays = [1, 4];
      message = "Available delivery days: Monday & Thursday";
   }

   else if (zip_location_3.includes(zipVal)) {
         allowedDays = [1, 3, 5];
      message = "Available delivery days: Monday, Wednesday & Friday";
   }

   else if (zip_location_4.includes(zipVal)) {
         allowedDays = [1, 2, 3, 4, 5];
      message = "Available delivery days: Monday - Friday";
   }

   else if (zip_location_5.includes(zipVal)) {
        allowedDays = [1, 3, 4];
      message = "Available delivery days: Monday, Wednesday & Thursday";
   }

   else {
     
      message = "Delivery is unavailable for this ZIP code.";
   }

   console.log(message)

   $("#zipMessage0").text(message);

});



   // DELIVERY / CURBSIDE SWITCH

if($('input[name="note_text"]:checked').val()){

    allowedDays = [0, 1, 2, 3, 4, 5, 6];

}

else {
    allowedDays = [];
}

   $('input[name="note_text"]').on("click", function () {

      if ($(this).val() == "Curbside Pickup") {

         allowedDays = [0, 1, 2, 3, 4, 5, 6];

         $("#curbside-message, #zip, #date").val("");

         $("#zipWrapper").hide();

         $("#curbside-message").show();

         $("#zipMessage0").text(
            "Please enter your zip code to confirm delivery availability."
         );

         $("#curbside-time").show();

          $('#checkoutButton').show();

      }

      if ($(this).val() == "Delivery") {

            allowedDays = [];


            




         $("#zipMessage0, #zipMessage").empty();

         $("#zipWrapper").show();

          $("#curbside-time").hide();


         $("#curbside-message").hide();





getCartTotal(function(cartTotal){

      console.log(cartTotal);

      if(cartTotal < 250){

         //alert("Delivery requires minimum order of $250");

    //  $('#checkoutButton').hide();

    //  $("#zipMessage0").text('Delivery requires minimum order of $250');

      return false;

         return false;

      }

      else {
           $('#checkoutButton').show();
   }
      }

   )


      }

   });


   // DATEPICKER
   $("#date").datepicker({

      dateFormat: "mm/dd/yy",

      minDate: +1,

      beforeShowDay: function(date) {

   var day = date.getDay();

     var month = date.getMonth();

   var today = new Date();

   var currentDay = today.getDay();


   var currentHour = today.getHours();

   // ONLY ALLOW DAYS FROM ZIP
   if (!allowedDays.includes(day)) {

      return [false];

   }




   return [true];

},

      onSelect: function () {

         var curDate = $("#date").datepicker("getDate");

         var dayName = $.datepicker.formatDate("DD", curDate);

         $("#day").val(dayName);

        





   

         var zipVal = $("#zip").val();

         // $("#curbside-message").val(
         //    "DELIVERY on " + dateVal + " for zip - " + zipVal
         // );

      },

      beforeShow: function () {

         var dateTime = new Date();

         var hour = dateTime.getHours();

         if (hour >= 12) {

            $(this).datepicker("option", "minDate", 2);

         }

      }

   });













   
   // curbside-message
   $("#curbside-message").datepicker({

      dateFormat: "mm/dd/yy",

       minDate: 0,

      beforeShowDay: function(date) {

   var day = date.getDay();

     var month = date.getMonth();

   var today = new Date();

   var currentDay = today.getDay();


   var currentHour = today.getHours();





    // never available on Monday

    if (day == 1) {

        return [false];

    }
   

  // Disable Sundays in July & August
    if ((month == 6 || month == 7) && day == 0) {

        return [false];

    }

   return [true];

},

      onSelect: function () {

         var curDate = $("#date").datepicker("getDate");

         var dayName = $.datepicker.formatDate("DD", curDate);

              


          var selectedDate = $(this).datepicker("getDate");

         const  selectDay = selectedDate.getDay();

         console.log(selectDay ==  0);

          let pickupTimes = [];

if(selectDay == 0){
     pickupTimes = [
    "9 am to 10 am",
    "10 am to 11 am",
    "11 am to 12 pm",
    "12 pm to 1 pm",
    "1 pm to 2 pm",
   
];
}

 else if(selectDay == 1){
     pickupTimes = [
  
   
];
}

// Pickup Dropdown Hours for Pickup


else{
      pickupTimes = [
    "9 am to 10 am",
    "10 am to 11 am",
    "11 am to 12 pm",
    "12 pm to 1 pm",
    "1 pm to 2 pm",
    "2 pm to 3 pm",
    "3 pm to 4 pm",
    "4 pm to 5 pm"
];
}

//console.log(pickupTimes+"Pickup time");

const curbsideTime = document.querySelector('#curbside-time');





if (selectedDate) {


    const selectBox = document.getElementById('curbside-time');

        selectBox.innerHTML = '';


    pickupTimes.forEach(element => {

        const alreadyExists = [...selectBox.options].some(
            option => option.value === element
        );

        if (!alreadyExists) {
        

            const createOptions = document.createElement('option');

            createOptions.value = element;

            createOptions.textContent = element;

            selectBox.appendChild(createOptions);

        }

    });

}




   

         var zipVal = $("#zip").val();

         // $("#curbside-message").val(
         //    "DELIVERY on " + dateVal + " for zip - " + zipVal
         // );

      },

 

   });


   // CHECKOUT BUTTON
   $("#checkoutButton").on("click", function (e) {

       e.preventDefault();

     // $("#zipMessage").empty();
      $("#zipMessage0").empty();

      var button = $(this);

      var dateVal = $("#date").val().trim();

      var zipVal = $("#zip").val().trim();

      var curbsideMessage = $("#curbside-message").val().trim();

      var radioValue = $("input[name='note_text']:checked").val();

      var day = $("#day").val();



      // CURBSIDE VALIDATION
      if (radioValue == "Curbside Pickup") {

         if (curbsideMessage == "") {

            alert("Please select day and time for curbside pickup.");

            return false;

         }

         button
            .prop("disabled", true)
            .text("⏳ Processing Order...");

         $('<input>')
   .attr({
      type: 'hidden',
      name: 'checkout',
      value: 'Checkout'
   })
   .appendTo('form[action="/cart"]');

$('form[action="/cart"]')[0].submit();

         return false;

      }


let totalprice=0;

   
if (radioValue == "Delivery") {

   getCartTotal(function(cartTotal){

      console.log(cartTotal);


      // ZIP + DATE VALIDATION
      if (zipVal == "" && dateVal == "") {

       //  alert("Please enter zip and date");

         $("#zipMessage0").text(
            'Please enter zip and date'
         );

         return;
      }

      if (zipVal == "") {

         alert("Please enter zip");

         return;
      }

      if (dateVal == "") {

         alert("Please enter date");

         return;
      }

      
      // STOP CHECKOUT
      if (cartTotal < 250) {

         $("#zipMessage0").text(
            'All delivery orders require a $250 minimum purchase.'
         );

         return;
      }

      // SUCCESS → SUBMIT CHECKOUT
      button
         .prop("disabled", true)
         .text("⏳ Processing Order...");

      $('<input>')
         .attr({
            type: 'hidden',
            name: 'checkout',
            value: 'Checkout'
         })
         .appendTo('form[action="/cart"]');

      $('form[action="/cart"]')[0].submit();

   });

   return false;
}


      // ZIP VALIDATION
      var isValid = false;



      // TUESDAY / FRIDAY
      if (
         zip_location_1.includes(zipVal) &&
         (day == "Tuesday" || day == "Friday")
      ) {

         isValid = true;

      }


      // MONDAY / THURSDAY
      else if (
         zip_location_2.includes(zipVal) &&
         (day == "Monday" || day == "Thursday")
      ) {

         isValid = true;

      }


      // MONDAY / WEDNESDAY / FRIDAY
      else if (
         zip_location_3.includes(zipVal) &&
         (day == "Monday" || day == "Wednesday" || day == "Friday")
      ) {

         isValid = true;

      }


      // ALL WEEKDAYS
      else if (
         zip_location_4.includes(zipVal) &&
         (
            day == "Monday" ||
            day == "Tuesday" ||
            day == "Wednesday" ||
            day == "Thursday" ||
            day == "Friday"
         )
      ) {

         isValid = true;

      }


      // MONDAY / WEDNESDAY / THURSDAY
      else if (
         zip_location_5.includes(zipVal) &&
         (day == "Monday" || day == "Wednesday" || day == "Thursday")
      ) {

         isValid = true;

      }



      // SUCCESS
      if (isValid) {

         button
            .prop("disabled", true)
            .text("⏳ Processing Order...");

         $("#zipMessage0").text("Redirecting to checkout...");

         $('<input>')
   .attr({
      type: 'hidden',
      name: 'checkout',
      value: 'Checkout'
   })
   .appendTo('form[action="/cart"]');

$('form[action="/cart"]')[0].submit();

      }


      // FAILED
      else {

         $("#zipMessage0").text(
            "Please select the correct delivery day for your zip code."
         );

         button
            .prop("disabled", false)
            .text("Checkout");

      }


      // FAILSAFE BUTTON RESET
      setTimeout(function () {

         button
            .prop("disabled", false)
            .text("Checkout");

      }, 10000);


      return false;

   });

});